import { Dispatch, SetStateAction } from 'react';
import { OwnershipFilter, DashboardInspectionStatus } from '../useInspectionList/types';

export enum SortDirection {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}

export enum SortByProperty {
  LAST_UPDATED = 'lastUpdated',
}

export interface DateFilter {
  min: Date;
  max: Date;
}

export interface DashboardInspectionListFilters {
  sortDirection: SortDirection;
  sortBy: SortByProperty;
  statuses: DashboardInspectionStatus[] | null;
  lastUpdated: DateFilter | null;
  searchInput: string | null;
}

export interface DashboardInspectionListParams extends DashboardInspectionListFilters {
  counts: Record<DashboardInspectionStatus | 'all', number> | null;
  ownershipFilter: OwnershipFilter;
  triggerEffect: boolean;
  setTriggerEffect: Dispatch<SetStateAction<boolean>>;
}
